module.exports = "<div ng-class=\"['checkbox-wrapper', {nolabel: $ctrl.noLabel}]\">\n    <input id=\"{{$ctrl.id}}\" type=\"checkbox\" ng-model=\"$ctrl.checked\">\n    <label for=\"{{$ctrl.id}}\">{{ $ctrl.label }}</label>\n</div><!-- /.checkbox-srapper -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpCheckbox/adpCheckbox.html
// module id = 669
// module chunks = 0